import * as React from "react";
const SvgFiRrCommentArrowUp = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comment-arrow-up_svg__a)">
      <path
        fill="#062147"
        d="M12.836.03A12.04 12.04 0 0 0 3.509 3.52a12.03 12.03 0 0 0-3.48 9.333C.469 19.208 6.082 24 13.083 24H19c2.757 0 5-2.243 5-5v-6.66C24 5.862 19.097.454 12.836.03M22 19c0 1.654-1.346 3-3 3h-5.917c-6.034 0-10.686-3.905-11.058-9.285a10.03 10.03 0 0 1 2.898-7.782 10.02 10.02 0 0 1 7.778-2.91C17.915 2.377 22 6.91 22 12.34zm-5.293-9.588a.999.999 0 1 1-1.414 1.414L13 8.533V17a1 1 0 1 1-2 0V8.634l-2.293 2.293a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.636-2.636a2.93 2.93 0 0 1 2.07-.876c.78 0 1.579.282 2.173.876l2.535 2.536"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comment-arrow-up_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentArrowUp;
